import { isoAndUnixZodSchema } from "@@/shared/date-time/iso-and-unix";
import type { Price} from "@@/shared/prices/price";
import { priceZodSchema } from "@@/shared/prices/price";
import type {
    Translatable} from "@@/shared/translations/translation";
import {
    translatableZodSchema,
} from "@@/shared/translations/translation";
import { z } from "zod";
import type { ReportItemId} from "./_report-item-id";
import { reportItemIdZodSchema } from "./_report-item-id";

type _ReportItemBase = {
    readonly _id: ReportItemId;
    readonly _type: "REPORT_ITEM";
    readonly title: Translatable;
    readonly description?: Translatable;
    readonly quantity: number;
    readonly pricePerItem: Price;
    readonly totalPrice: Price;
    readonly account?: string;
};

const _reportItemBaseZodSchema: z.ZodSchema<_ReportItemBase> = z.object({
    _id: reportItemIdZodSchema,
    _type: z.literal("REPORT_ITEM"),
    _createdAt: isoAndUnixZodSchema,
    title: translatableZodSchema,
    description: translatableZodSchema.optional(),
    quantity: z.number().min(1),
    pricePerItem: priceZodSchema,
    totalPrice: priceZodSchema,
    account: z.string().optional(),
});

export type { _ReportItemBase };
export { _reportItemBaseZodSchema };
